import "../css/tailwind.css";
import "../css/screen.css";

"use strict";

document.addEventListener('DOMContentLoaded', (event) => {
  const latestPostsLink = document.querySelector('a[href="#latest-posts"]');
  if (latestPostsLink) {
      latestPostsLink.addEventListener('click', function(e) {
          e.preventDefault();
          const latestPostsSection = document.getElementById('latest-posts');
          if (latestPostsSection) {
              const yOffset = -80; 
              const y = latestPostsSection.getBoundingClientRect().top + window.pageYOffset + yOffset;
              window.scrollTo({top: y, behavior: 'smooth'});
          }
      });
  }
});

function setupSmoothScroll() {
  const links = document.querySelectorAll('a[href^="#"]');
  links.forEach(link => {
    link.addEventListener('click', function(e) {
      const href = this.getAttribute('href');
      if (href.startsWith('#')) {
        e.preventDefault();
        const targetElement = document.querySelector(href);
        if (targetElement) {
          const yOffset = -80; 
          const y = targetElement.getBoundingClientRect().top + window.pageYOffset + yOffset;
          window.scrollTo({top: y, behavior: 'smooth'});
        }
      }
    });
  });
}

window.addEventListener('load', setupSmoothScroll);

function addNotProseClass() {
  let e = document.querySelectorAll(".kg-card");
  e.forEach((e) => {
    e.classList.add("not-prose");
  });
}
function initializePagination(e) {
  let t = window.pagination;
  "function" == typeof t && t(e);
}
function setupFsLightbox() {
  let e = window.refreshFsLightbox;
  if ("function" == typeof e) {
    let t = document.querySelectorAll(".kg-gallery-image img");
    t.forEach((e) => {
      let t = document.createElement("a");
      t.setAttribute("data-no-swup", ""),
        t.setAttribute("data-fslightbox", ""),
        t.setAttribute("href", e.src),
        e.parentNode.insertBefore(t, e),
        t.appendChild(e);
    }),
      e();
  }
}
function setupMobileMenu() {
  let e = document.querySelector(".hamburger"),
    t = document.querySelector(".mobile-menu"),
    o = document.querySelector(".main-navbar");
  e &&
    e.addEventListener("click", function () {
      e.classList.toggle("open"),
        t.classList.toggle("!flex"),
        o.classList.toggle("!top-0")
    });
}
function insertFooterSeparator() {
  let separator = document.createElement("i");
  separator.classList.add(
    "separator",
    "cursor-default",
    "text-[11px]",
    "!text-zinc-400",
    "dark:!text-zinc-600",
    "hidden",
    "sm:block"
  );
  separator.innerHTML = "•";
  let footerLinks = document.querySelectorAll(".footer-links a");
  for (let i = 0; i < footerLinks.length; i++) {
    if (i < footerLinks.length - 1) {
      let currentLink = footerLinks[i];
      currentLink.parentNode.insertBefore(separator.cloneNode(true), currentLink.nextSibling);
    }
  }
}
function checkAndAdjustTableSize() {
  let e = document.querySelectorAll("table:not(.v2)");
  e.forEach((e) => {
    let t = !1;
    function o(e) {
      let o = e.closest('div[class^="content"]'),
        l = e.offsetWidth,
        i = o.offsetWidth;
      l > i
        ? (e.classList.add("!block"), e.classList.remove("!table"), (t = !0))
        : (e.classList.add("!table"), e.classList.remove("!block"), (t = !1));
    }
    o(e),
      window.addEventListener("resize", function () {
        t || o(e);
      });
  });
}
function adjustTextColorBasedOnBackground() {
  let e = document.querySelector(".kg-signup-card");
  if (e) {
    let t = window.getComputedStyle(e).getPropertyValue("background-color");
    if ("rgb(0, 0, 0)" === t) {
      let o = e.querySelectorAll("*:not(.kg-signup-card-button)");
      o.forEach((e) => {
        e.style.color = "white";
      });
    }
  }
}
function removeJavaScriptLinks() {
  let e = document.querySelectorAll(".footer-social-account-link");
  for (let t = 0; t < e.length; t++)
    e[t].href.startsWith("javascript:") && e[t].remove();
}
function disableImageDrag() {
  for (var e = document.getElementsByTagName("img"), t = 0; t < e.length; t++)
    e[t].ondragstart = function () {
      return !1;
    };
}

function postNavbar(className) {
  document.querySelectorAll(className).forEach(function(navbar) {
    function scrollFunction() {
      if (window.scrollY > 120 || window.pageYOffset > 120) {
        navbar.classList.add('!translate-y-0');
      } else {
        navbar.classList.remove('!translate-y-0');
      }
    }
    window.addEventListener('scroll', scrollFunction);
    scrollFunction();
  });
}


/**
 * Function to decode HTML entities such as &lt;, &gt;, and &amp;
 * in elements with the class 'ghost-link-fix'.
 */
const decodeHtmlEntities = () => {
  const elements = document.querySelectorAll('.ghost-link-fix');
  elements.forEach((element) => {
    element.innerHTML = element.innerHTML
      .replace(/&lt;/g, '<')
      .replace(/&gt;/g, '>')
      .replace(/&amp;/g, '&');
  });
};


function initializeAllFeatures() {
  addNotProseClass(),
    initializePagination(!1),
    setupFsLightbox(),
    setupMobileMenu(),
    adjustTextColorBasedOnBackground();
}
window.addEventListener("load", function () {
  initializeAllFeatures();
}),
  disableImageDrag(),
  insertFooterSeparator(),
  removeJavaScriptLinks(),
  checkAndAdjustTableSize(),
  postNavbar('.post-nav');
decodeHtmlEntities();